enum SocialCategories {
  emotional_symptoms = 'emotional_symptoms',
  hyperactivity = 'hyperactivity',
  peer_problems = 'peer_problems',
  prosocial = 'prosocial',
  conduct_problems = 'conduct_problems'
}

export default SocialCategories



// WEBPACK FOOTER //
// ./src/data/questionnaires/Types/Social/SocialCategories.ts